import { AxiosPromise } from "axios";
import {
  DashboardDto,
  DashboardResourceApi, IntercomDataDto, StreamResourceApi,
  TimberFont,
  Token, TokenRequestDto,
} from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";

const api = new DashboardResourceApi(dashboardApiConfig);
const streamApi = new StreamResourceApi(dashboardApiConfig);

const DashboardApi = {
  status(): AxiosPromise<DashboardDto> {
    return api.status(ops());
  },
  getFonts(): AxiosPromise<TimberFont[]> {
    return api.getFonts(ops());
  },
  getIntercomData(): AxiosPromise<IntercomDataDto> {
    return api.intercomData(ops());
  },
  getOAuthToken(): AxiosPromise<string> {
    return api.getOAuthToken(ops());
  },
  getStreamOAuthToken(dto: TokenRequestDto): AxiosPromise<Token> {
    return streamApi.getStreamOAuthToken(dto, ops());
  }
};

export default DashboardApi;
